import { useMemo } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import Slider from "react-slick";
import FaceScan from "../assets/images/FaceScan.webp";
import FingerScan from "../assets/images/FingerScan.webp";
import InstructionFaceScan1 from "../assets/images/instructions/face1.webp";
import InstructionFaceScan2 from "../assets/images/instructions/face2.webp";
import InstructionFaceScan3 from "../assets/images/instructions/face3.webp";
import InstructionFaceFingerScan from "../assets/images/instructions/face-finger.webp";
import InstructionFingerScan1 from "../assets/images/instructions/finger1.webp";
import InstructionFingerScan2 from "../assets/images/instructions/finger2.webp";

const settings = {
  dots: true,
  lazyLoad: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay: true,
  Arrow: false,
  autoplaySpeed: 2500,
  pauseOnDotsHover: false,
};

const ScanInstructions = () => {
  const location = useLocation();
  const scanType = location.state?.scanType;

  const instructions = useMemo(
    () =>
      ({
        face: [
          {
            img: InstructionFaceScan1,
            desc: "The ambient light should be bright, consistent, and white.",
          },
          {
            img: InstructionFaceScan2,
            desc: "Remove any face-obstructing items, such as your mask, eyewear, or clothing.",
          },
          {
            img: InstructionFaceScan3,
            desc: "Keep your face and phone steady to avoid movements during the scan.",
          },
          {
            img: InstructionFaceFingerScan,
            desc: "If prompted, allow the camera permission.",
          },
        ],
        finger: [
          {
            img: InstructionFingerScan1,
            desc: "Place your finger on the rear primary camera and the flashlight.",
          },
          {
            img: InstructionFingerScan2,
            desc: "If the flash is not turned on then place some light behind the phone.",
          },
          {
            img: InstructionFaceFingerScan,
            desc: "If prompted, allow the camera permission.",
          },
        ],
      }[scanType] ?? []),
    [scanType]
  );

  return scanType === "face" || scanType === "finger" ? (
    <section className="px-8 pt-2 pb-6">
      <div className="flex items-center justify-between space-x-4">
        <h2 className="text-2xl font-semibold">
          How to do a<br />
          <span className="text-secondary capitalize">{scanType} Scan</span>?
        </h2>
        <img
          className="shrink-0 h-28 rounded-full border-4 border-dotted border-white"
          src={scanType === "face" ? FaceScan : FingerScan}
          alt="Instruction"
        />
      </div>

      <Slider {...settings} className="mt-8 instruction-slide">
        {instructions.map((ins, idx) => (
          <div className="px-0.5">
            <img
              className="h-48 w-full object-fill rounded-2xl border-2 border-secondary"
              src={ins.img}
              alt={`Instruction Banner ${idx + 1}`}
            />
            <p className="mt-4 text-center leading-snug">{ins.desc}</p>
          </div>
        ))}
      </Slider>

      <Link
        className="block mt-6 w-full rounded-full outline-none px-5 py-2.5 bg-gradient text-white text-center"
        to={`/${scanType}-scan`}
      >
        Understood, Let's Start
      </Link>
      <Link
        to={-1}
        className="block max-w-max mx-auto mt-4 text-sm font-medium"
      >
        Back
      </Link>

      <div className="mt-6 p-4 rounded-xl bg-gradient-transparent text-white space-y-1.5">
        <h3 className="text-xs font-medium">Disclaimer</h3>
        <p className="text-xxs text-justify">
          For Investigational Use Only. CarePlix is not a substitute for the
          clinical judgment of a healthcare professional. CarePlix is intended
          to improve your awareness of general wellness. CarePlix does not
          diagnose, treat, mitigate or prevent any disease, symptom, disorder or
          abnormal physical state. Consult with a healthcare professional or
          emergency services if you believe you may have a medical issue.
        </p>
      </div>
    </section>
  ) : (
    <Navigate to="/select-option" replace />
  );
};

export default ScanInstructions;
